<template>
	<div>
		<div class="wrapper">
			<div class="extension-wrap">
				<div class="exLogo">
					<img src="../../assets/images/extension/bg-1.jpg" class="bg1">
					<img src="../../assets/images/extension/ex-logo.png" alt="" class="logoImg">
				</div>

				<img src="../../assets/images/extension/bg-2.jpg" class="bg2">
				<div class="floor-wrap">
					<div class="ex-floor1">

						<div class="p-title">
							<img src="../../assets/images/extension/tit1.png" alt="">
						</div>
						<div class="ex-form">
							<div class="item">
								<input type="text" placeholder="公司名称"  v-model="companyName" maxlength="20">
							</div>
							<div class="item item-type">
								<select name="" @change="selectType($event)">
									<option value="公司类型" disabled="disabled" selected="selected">公司类型</option>
									<option value="1">小规模</option>
									<option value="2">一般纳税人</option>
								</select>
								<i></i>
							</div>
							<div class="item">
								<input type="number" placeholder="手机号" maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'') " v-model="phone">
							</div>
							<div class="item item-code">
								<input type="text" placeholder="图形验证码" maxlength="4" v-model="imagesCode">
								<div class="code-r">
									<canvas id="canvas" class="codeImg"></canvas>
									<!-- <img src="../../assets/images/extension/yzm.png" alt=""> -->
									<i @click="imgCode"></i>
								</div>
							</div>
							<div class="item-policy">
								<label>
									<input type="checkbox" name="" id="" value=""  v-model="checked"/>同意
								</label>
								<router-link :to="{ name:'agreement' }" style="margin-right: 2px;">零分享服务协议</router-link> 和
								<router-link :to="{ name:'policy' }" style="margin-left: 2px;">隐私政策</router-link>
							</div>
							<button type="button" class="submit-btn" @click="submitConsult()">立即提交</button>
						</div>
					</div>

				<div class="ex-floor2">
					<div class="p-title">
						<img src="../../assets/images/extension/tit2.png" alt="">
					</div>

					<div class="floor2-wrap">
						<ul>
							<li v-for="(item,index) in serviceList">
								<img :src='"../../assets/images/extension/service-"+(index+1)+".png"'>
								<span>{{item}}</span>
							</li>
						</ul>
					</div>
				</div>

				</div>
				<div class="ex-floor3">
					<div class="p-title">
						<img src="../../assets/images/extension/tit3.png" alt="">
					</div>

					<ul>
						<li>
							<img src="../../assets/images/extension/choose-1.png" >
							<p>专业团队支持</p>
							<em></em>
							<span>专业团队支持  丰富行</span>
							<span>业经验</span>
						</li>
						<li>
							<img src="../../assets/images/extension/choose-2.png" >
							<p>企业需求导向</p>
							<em></em>
							<span>企业需求导向  精准方</span>
							<span>案策划</span>
						</li>
						<li>
							<img src="../../assets/images/extension/choose-3.png" >
							<p>全程收费透明</p>
							<em></em>
							<span>全程收费透明  诚信可</span>
							<span>靠安心</span>
						</li>
						<li>
							<img src="../../assets/images/extension/choose-4.png" >
							<p>多元增值服务</p>
							<em></em>
							<span>多元增值服务  满足全</span>
							<span>面需求</span>
						</li>
					</ul>
				</div>

				<div class="foot">
					<span>上海蜜瓣网络科技有限公司</span>
					<p>Copyright © 2011-2020 沪ICP备18035332号-2</p>
				</div>

			</div>

			<div class="model" v-show="successState">
				<div class="success-box blockCenter">
					<div class="success-info">
						<img src="../../assets/images/extension/success.png">
						<span>提交成功</span>
						<p>信息已经提交，稍后会有专业客服为您服务</p>
					</div>
					<img src="../../assets/images/extension/close.png" alt="" class="close-btn" @click="closeModel()">
				</div>
			</div>
		</div>
	</div>
</template>


<script>

    import "../../assets/css/extension.css"
	import { Toast } from 'vant'
	import {VidateUtil} from '../../assets/js/validate.js'

    export default {
		data(){
		    return{
		        successState:false,  //提交成功的弹窗
				companyName:'',
				phone:'',
				imagesCode:'',  //填写的验证码
				picCode:'',    //接收的验证码
				utm_source:"utm_source",
				utm_term:"utm_term",
				utm_content:"utm_content",
				utm_campaign:"utm_campaign",
				companyType:"", //公司类型
				checked: true,  //服务协议按钮
				serviceList:["公司注册","企业变更","代理记账","税务筹划","税务咨询","公司注销","社保开户","定制代记账","店铺运营指导"]
			}
		},
    	components: {
    		VidateUtil
    	},
		methods:{
			// 提交表单
			submitConsult(){
				if(this.companyName == ""){
					Toast("必须填写公司名称")
					return false;
				}else if(this.phone == '' || this.phone == null) {
					Toast("手机号码不能为空")
					return false;
				} else if(!/^1[3456789]\d{9}$/.test(this.phone)) {
					Toast("手机号格式有误")
					return false;
				}else if(this.imagesCode == ""){
					Toast("必须填写图片验证码")
					return false;
				}else if(this.imagesCode.toLowerCase() != this.picCode.toLowerCase()){
					Toast("图片验证码不正确")
					return false;
				}else if( this.checked == false ){
					Toast("必须勾选协议")
					return false;
				}else{
                    let params = {
                        companyName: this.companyName,
                        companyType: this.companyType,
                        mobile: this.phone,
                        picCode: this.imagesCode,
                        channelId: this.utm_source,
                        medium: this.utm_medium,
                        term: this.utm_term,
                        content: this.utm_content,
                        campaign: this.utm_campaign
                    }
                    this.axios({
                        method: 'post',
                        url: '/promote/addPromote',
                        data: this.$qs.stringify(params)
					}).then((res)=>{
						if( res.data.code == "1000"){
							this.successState = !this.successState;
							this.companyName = "";
							this.phone = "";
							this.imagesCode = "";
							return;
						}else{
							Toast(res.data.message)
							return;
						}

					}).catch((err)=>{
					    this.$message.error({message: '网络异常，请稍后重试'});
					})
				}
			},
			// 选择公司类型
			selectType(event){
				this.companyType = event.target.value
			},
			// 关闭成功弹窗
			closeModel(){
				this.successState = false;
			},
			//获取图形验证码
			imgCode(){
				this.axios({
				    method: 'POST',
				    url:'/sendCode',
				}).then((res)=>{
					let data = res.data;
					this.picCode = data;
					VidateUtil.drawPic(data);
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			// 获取地址栏参数
			GetRequest(){
				var url = location.search; //获取url中"?"符后的字串
				var theRequest = new Object();
				if (url.indexOf("?") != -1) {
					var str = url.substr(1);
					var strs = str.split("&");
					var index;
					for(var i = 0; i < strs.length; i ++) {
						// console.log(strs[i].split("=")[0]+"-----"+unescape(strs[i].split("=")[1]));
						if(strs[i].split("=")[0] == "utm_source"){
							index = 0;
						}else if(strs[i].split("=")[0] == "utm_medium"){
							index = 1;
						}else if(strs[i].split("=")[0] == "utm_term"){
							index = 2;
						}else if(strs[i].split("=")[0] == "utm_content"){
							index = 3;
						}else if(strs[i].split("=")[0] == "utm_campaign"){
							index = 4;
						}
						theRequest[index] = decodeURI(strs[i].split("=")[1]);
					}
				}
				return theRequest;
			}
		},
		mounted() {
			// 获取图形验证码
			this.imgCode();
			// 获取地址栏参数
			var param = new Object();
			param = this.GetRequest();

			if( param[0] != "undefined" ){
				this.utm_source = param[0];
			}else{
				this.utm_source = ""
			}

			if( param[1] != "undefined" ){
				this.utm_medium = param[1];
			}else{
				this.utm_medium = ""
			}

			if( param[2] != "undefined" ){
				this.utm_term = param[2];
			}else{
				this.utm_term = ""
			}

			if( param[3] != "undefined" ){
				this.utm_content = param[3];
			}else{
				this.utm_content = ""
			}

			if( param[4] != "undefined" ){
				this.utm_campaign = param[4];
			}else{
				this.utm_campaign = ""
			}
		}
    }
</script>